import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import TableWidget from '../TableWidget.js';

const handleDataChange = (data, name, evt, index, isNew) => {
    if (isNew) {
        data['code'] = data['name'].toLowerCase().replace(/\s+/g, '_');
        return;
    }
    else {
        data[index][name] = evt.target.value;
        data[index]['code'] = evt.target.value.toLowerCase().replace(/\s+/g, '_');
    }
}

class DepartmentTypes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DepartmentTypes: [],
        }
        this.loadData = this.loadData.bind(this);
        this.handleUserDataChange = this.handleUserDataChange.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }


    loadData = () => {
        const { currentEntity } = this.props.clientStore;

        if (currentEntity.client.data && currentEntity.client.data.roles) {
            const departments = currentEntity.client.data.roles;
            this.setState({
                DepartmentTypes: departments
            })
        }
    }

    handleUserDataChange = (name, value) => {
        const { currentEntity } = this.props.clientStore;

        if (currentEntity.client.data.roles) {
            currentEntity.client.data.roles = value;
        }
    }

    render() {
        const { DepartmentTypes } = this.state;
        const { t } = this.props;
        return (
            <div>
                <div className="mt-2 custom-card">
                    <h6>{t('Departments')}</h6>
                    <TableWidget
                        headers={['Departments']}
                        metaData={[{ field: 'name', type: 'text', placeholder: 'Label', required: true, uniqueWithoutCase: true }]}
                        data={DepartmentTypes}
                        onChange={data => this.handleUserDataChange('roles', data)}
                        page={'department'}
                        customHandleChange={handleDataChange}
                    />
                </div>
            </div>
        );
    }
}
export default inject('clientStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(DepartmentTypes))));
